export default function localTime(date) {
  return new Date(date).toLocaleTimeString()
}
